import { supabase, isDemoMode } from './supabase';
import { getDemoStudents, setDemoStudentActive } from './demoData';

/**
 * Fetch all student profiles (admin only — RLS enforces this).
 * Returns { data: Profile[], error }
 */
export async function getAllStudents() {
  if (isDemoMode) return { data: getDemoStudents(), error: null };
  return supabase
    .from('profiles')
    .select('*')
    .eq('role', 'student')
    .order('last_name', { ascending: true });
}

/**
 * Fetch a single profile by user ID.
 * Returns { data: Profile, error }
 */
export async function getStudentProfile(userId) {
  if (isDemoMode) {
    const found = getDemoStudents().find((s) => s.id === userId) || null;
    return { data: found, error: null };
  }
  return supabase.from('profiles').select('*').eq('id', userId).single();
}

/**
 * Activate or deactivate a student account.
 * Demo mode: updates in-memory store (persists for the session).
 * Returns { error }
 */
export async function setUserActive(userId, isActive) {
  if (isDemoMode) {
    setDemoStudentActive(userId, isActive);
    return { error: null };
  }
  return supabase.from('profiles').update({ is_active: isActive }).eq('id', userId);
}

/**
 * Create a student account on behalf of an admin.
 * Returns { data, error }
 */
export async function createStudentByAdmin({ firstName, lastName, username, email, password }) {
  if (isDemoMode) return { error: { message: 'Demo mode: new accounts cannot be created without Supabase.' } };
  return supabase.functions.invoke('admin-create-user', {
    body: { firstName, lastName, username, email, password },
  });
}

/**
 * Look up a profile by username (used during login to resolve email).
 * Returns { data: Profile | null, error }
 */
export async function getProfileByUsername(username) {
  if (isDemoMode) return { data: null, error: null };
  const { data, error } = await supabase
    .from('profiles')
    .select('email')
    .eq('username', username)
    .maybeSingle();
  return { data, error };
}
